export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/laptop.db47d2d2-a23b88.png";